import EngineCleanupBase from '../../../services/engines/EngineCleanupBase';
import componentNotifier from '../../../services/wss/ComponentNotifier';
import responseHelper from '../../../services/ResponseHelper';
import dataEnvelopeService from '../../../services/DataService';
import formConfigCache from './FormConfigCache';
import formConfigFetcher from './FormConfigFetcher';
import { EngineNames } from '../../../services/wss/events/EngineNames';
import formBuilderFormState from './FormBuilderFormState';

const _name = EngineNames.FormConfigEngine;
const TOPIC = 'Jerny.FormBuilderConfigs';

class FormConfigEngine extends EngineCleanupBase {
    //
    // the selected form config from LoadFormConfigDlg
    _selected = formBuilderFormState.createDefault();

    /**
     * initialize engine
     */
    bootup = () => {
        this.initialize(_name);
    };

    /**
     * fetch all form config notes from BE
     */
    fetchAll = async () => {
        await formConfigFetcher.fetch();
    };

    /**
     * set the selected config note
     *
     * @param {*} entry the selected Form config note
     */
    setSelected = (entry) => {
        try {
            this._selected = entry;
            this._notify();
        } catch (error) {
            this.logError('setSelected', error.message);
        }
    };

    getSelected = () => {
        return this._selected;
    };

    /**
     * update form config notes in cache
     *
     * @param {*} entries the updted entries from BE from SignalR
     * @returns
     */
    onJournalUpdated = (entries) => {
        try {
            if (!Array.isArray(entries) || !entries.length) {
                return false;
            }

            // get all form config types
            const items = entries.filter((x) => x.type === 'FormBuilderConfig');
            if (items.length === 0) {
                return;
            }

            // convert to form config from body
            const configs = [];

            items.forEach((x) => {
                const cfg = JSON.parse(x.body);
                cfg.rk = x.rk;

                configs.push(x);
            });

            // update cache
            formConfigCache.addOrUpdate(configs);

            // was changed so notify
            this._notify();
            return true;
        } catch (error) {
            this.logError('onJournalUpdated', error.message);
            return false;
        }
    };

    /**
     * Called directly from PageContentSRHandlers on OnJournalDeleted.
     * @param {string} rk
     */
    onJournalDeleted = (rk) => {
        try {
            if (!rk) {
                this.logError('onJournalDeleted', `Invalid row key - ${rk}`);
                return false;
            }

            // remove it from cache
            const deleted = formConfigCache.delete(rk);
            if (!deleted) {
                return;
            }

            // if (this._selectedEntry?.rk === rk) {
            //     this._selectedEntry = null;
            // }

            this._notify();

            return deleted;
        } catch (error) {
            this.logError('onNoteDeleted', error.message);
            return false;
        }
    };

    // ─── private ──────────────────────────────────────────

    _notify = () => {
        componentNotifier.notify(EngineNames.FormConfigEngine, 'dataChanged', {
            items: formConfigCache.getAll(),
            selected: this._selected,
        });
    };

    clear = () => {
        formConfigCache.clear();
        super.clear();
    };
}

const formConfigEngine = new FormConfigEngine();
export default formConfigEngine;
